import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ExpeditionsCategories.scss";
import { fetchCategories } from "../services/tripServices";
import { IMAGE_BASE_URL } from "../config";


const ExpeditionsCategories = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories('expeditions').then((data) => {
      setCategories(data);
    }).catch((error) => {
      console.error("Error fetching categories:", error);
    });
  }, []);
  return (
    <section className="expeditionsCategories">
      <h2 className="sectionTitle">Legendary Expeditions</h2>
      <div className="categoriesGrid">
        {categories.map((cat, index) => (
          <Link to={`/category/${cat.name}-${cat.type}`} key={index} className="categoryCard">
            <div className="cardImage">
              <img crossOrigin="anonymous" src={`${IMAGE_BASE_URL}/${cat.thumbnailImage}`} alt={cat.name} />
            </div>
            <div className="cardOverlay">
              <h3>{cat.name}</h3>
              <p>{cat.description}</p> {/* description hover pe show hogi */}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ExpeditionsCategories;
